<!--
 * A Vue component that implements a close icon.
 *
 *
 * Properties
 * ==========
 * - id
 * (Optional) The text that is used as id for he image.
 *
 * - iconColor
 * (Optional) Color for the icon, default is white.
 *
 * Events
 * ==========
 * - close
 * This event is sent when user changes clicks the close button.
 *
 * Usage
 * ==========
 * -You must listen to the 'close' event an write the code to close the form.
 *
 *  <icon-close
 *      @close="[close event handler reference]">
 *  </icon-close>
 *
-->
<template>
    <div>
        <!-- close icon -->
        <a :id="id"
           class="close-icon float-right"
           :class="iconColor"
           @click="$_onClose"
           :title="$t('btnCloseLabel')"></a>
    </div>
</template>

<script>
    export default {
        name: 'IconClose',

        props: {
            id: { type: String, required: false, default: 'close-icon' },
            iconColor: { type: String, default: 'close-white-icon' }
        },

        methods: {
            $_onClose(event) {
                this.$emit('close', event);
            }
        }
    };
</script>

<style lang="scss" scoped>
    .close-icon {
        width: 22px;
        height: 25px;
        background-size: 22px;
        cursor: pointer;
        text-indent: 999em;
        overflow: hidden;
        -webkit-mask-size: 22px;
        mask-size: 22px;
        -webkit-mask-position: center;
        mask-position: center;
    }
</style>
